import React from "react";
import { compose, withAppContext, withActions } from "containers/HOC";
import { Link } from "react-router-dom";
import ActionLink from "components/ActionLink";
import { modal } from "containers/App/_actions";
import * as _utils from "./_utils";
import ZendeskLink from "components/Help/ZendeskLink";
import ScenarioToolLink from "containers/ScenarioTool/ScenarioToolLink";

class AnimalsActionBar extends React.Component {
    addEnterprise = (e) => {
        const { farm, budget, modal } = this.props;
        const viewModel = { farm, budget };
        modal("CreateEnterpriseModal", null, viewModel);
    };

    render() {
        const { farm, budget, refData } = this.props;
        const options = _utils.getEnterpriseTypeOptions(budget, refData);
        const hasDairy = options.some((o) => o.value === "Dairy" && o.disabled);
        const canDistributeAnimals = (budget.enterprises || []).length > 0 && budget.blocks.some((block) => _utils.canDistributeAnimals(block));
        const canAddEnterprise = options.filter((o) => !o.disabled).length > 0;

        return (
            <div className="ActionsBar ActionsBar--super u-print-none">
                <div className="ActionsBar-left">
                    <ul className="ActionsBar-links">
                        {canDistributeAnimals && (
                            <li>
                                <Link to={`/app/farm/${farm.id}/analysis/${budget.id}/animals/distribution`} className={`IconLink--settings${canDistributeAnimals === false ? " is-disabled" : ""}`} id="edit-distribution-link">
                                    Animal distribution
                                </Link>
                            </li>
                        )}
                        {options
                            .filter((o) => o.disabled && (o.value !== "DairyReplacements" || hasDairy))
                            .map((option) => {
                                return (
                                    <li key={option.value}>
                                        <Link to={`/app/farm/${farm.id}/analysis/${budget.id}/animals/enterprises/${option.value.toLowerCase()}`} className="IconLink--settings" id={`manage-${option.value}`}>
                                            {option.text.replace("- ", "")}
                                        </Link>
                                    </li>
                                );
                            })}
                    </ul>
                </div>
                {canAddEnterprise && (
                    <div className="ActionsBar-right">
                        <ul className="ActionsBar-links">
                            <li>
                                <ActionLink onClick={this.addEnterprise} className="IconLink--arrow-plus" id="add-enterprise-link">
                                    Add enterprise
                                </ActionLink>
                            </li>
                            {process.env.REACT_APP_DISABLE_SCENARIO_TOOL !== "true" && (
                                <li>
                                    <ScenarioToolLink farm={farm} analysisId={budget.id} />
                                </li>
                            )}
                            <li>
                                <ZendeskLink title="Page help" url="https://support.overseer.org.nz/hc/en-us/articles/900000978243" className="IconLink--new-tab u-font-green" />
                            </li>
                        </ul>
                    </div>
                )}
            </div>
        );
    }
}

export default compose(withAppContext, withActions({ modal }))(AnimalsActionBar);
